import {PAGE_DIRTY_PAYLOAD} from '../Types/types'

export function storePageDirtyPayload(data: any) {
  return {
    type: PAGE_DIRTY_PAYLOAD,
    payload: data
  }
}
